import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { toast } from "react-toastify";
import FormDrawer from "src/components/Form/FormDrawer";
import { updateBrandSaga } from "src/store/brands/saga";
import { BrandDetailDto } from "src/store/brands/type";
import * as Yup from "yup";
import { SectorDto } from "src/store/system/type";
import { getSectors } from "src/store/system/saga";

const BrandsEditForm = ({
  data,
  onHide,
  open,
  onSuccessClick,
}: {
  data: BrandDetailDto;
  onSuccessClick: (message: string) => void;
  onHide: () => void;
  open: boolean;
}) => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const [sectors, setSectors] = useState<SectorDto[]>([]);
  useEffect(() => {
    open &&
      dispatch(
        getSectors({
          payload: {
            onSuccess: (m, p) => setSectors(p),
            onError: () => {},
          },
        })
      );
  }, [dispatch, open]);
  return (
    <React.Fragment>
      <FormDrawer
        drawerProps={{
          isOpen: open,
          onHide: onHide,
          title: t("Brand.EditFormTitle").toString(),
        }}
        onHide={onHide}
        loader
        initialValues={{
          Id: data.Id,
          ParentBrandId: data.ParentBrandId,
          Name: data.Name,
          SectorId: data.SectorId,
          Translates: data.Translates.map((x) => {
            return {
              LanguageId: x.LanguageId,
              Title: x.Name,
            };
          }),
        }}
        validationSchema={Yup.object().shape({
          Name: Yup.string().required(t("Validation.Required").toString()),
          SectorId: Yup.string().required(t("Validation.Required").toString()),
        })}
        onSubmit={(values) => {
          dispatch(
            updateBrandSaga({
              payload: {
                onSuccess: (message, payload) => {
                  onHide();
                  onSuccessClick(message);
                },
                onError: (message) => {
                  toast.error(message, {
                    theme: "colored",
                  });
                },
              },
              id: data.Id,
              body: values,
            })
          );
        }}
        multilanguageinputs={[
          {
            field: "Name",
            label: t("Brands.Name").toString(),
          },
        ]}
        inputs={[
          {
            field: "SectorId",
            label: t("Brands.Sector").toString(),
            type: "select",
            lookup: {
              labelKey: "Name",
              valueKey: "Id",
              options: sectors,
            },
          },
        ]}
      />
    </React.Fragment>
  );
};
export default BrandsEditForm;
